<template>
  <DialogTemplateToolkit
    :data-qa="'modal-rating-' + (ratingsDialog.modal ? 'open' : 'close')"
    :dialog="ratingsDialog.modal"
    footer_class="pt-2"
    :title="title"
    without_first_btn
    without_second_btn
    @close="changeStateModalRatind(false)">
    <template #activator-btn>
      <MenuItem
        v-if="list"
        data-qa="estimate-supplier"
        :disabled="sendRating || $acl.get.includes('tenders_view')"
        icon="star-outline"
        :label="$t('Common.EstimateSupplier')"
        :loading="sendRating"
        @click.stop="changeStateModalRatind(true)"/>
      <template v-else>
        <sButton
          data-qa="btn-add-rating"
          :disabled="sendRating || $acl.get.includes('tenders_view')"
          @click.stop="changeStateModalRatind(true)">
          {{ $t('Suppliers.Evaluate') }}
        </sButton>
      </template>
    </template>
    <template #card-text>
      <div>
        <template v-if="ratingsDialog.modalStep === 1">
          <sForm
            ref="ratingDialogForm"
            :model="ratingsDialog.modalData"
            :rules="rules">
            <sFormItem
              prop="generalRating">
              <div class="font-size-16 text-left bold">
                <span
                  class="h5-headline secondary__red--text">*</span>
                {{ $t('Suppliers.OverallRating') }}
              </div>
              <RatingStar
                class="row pt-4 my-0 mx-0"
                data-qa="generalRating"
                :disabled="sendRating"
                :size="26"
                :value.sync="ratingsDialog.modalData.generalRating"/>
            </sFormItem>
            <div class="mt-9 mb-4 font-size-16 text-left bold">
              {{ $t('Common.DetailedAssessment') }}
            </div>
            <div
              v-for="(typeRating, typeRatingIndex) in ratingsDialog.modalData.ratingTypes"
              :key="`typeRating-${typeRatingIndex}`"
              class="pt-5 ml-0 row"
              style="flex-wrap: nowrap;">
              <RatingStar
                class="my-0 mx-0"
                :data-qa="`typeRating-${typeRatingIndex}`"
                :disabled="sendRating"
                :value.sync="ratingsDialog.modalData.ratingDetails[typeRatingIndex].rating"/>
              <div class="ml-9 font-size-16 text-left bold">
                {{ typeRating.criteriaName }}
              </div>
            </div>
            <div class="mt-5 font-size-16 text-left bold text-capitalize">
              {{ $t('Suppliers.Comment') }}
            </div>
            <sFormItem
              prop="comment">
              <div class="row-comment">
                <sInput
                  id="comment"
                  class="col-textarea"
                  data-qa="modal-rating-comment"
                  :disabled="sendRating"
                  :max-length="250"
                  :not_grow="true"
                  rows="7"
                  type="textarea"
                  :value.sync="ratingsDialog.modalData.comment"/>
                <div
                  class="col-info"
                  data-qa="ratings-alert">
                  <div
                    class="px-6 py-4 secondary__green_chosen text-left"
                    style="border-radius: 5px;height: 100%;">
                    <div class="bold">
                      {{ $t('Common.PleaseNote') }}
                    </div>
                    <div
                      class="pt-1"
                      style="line-height: 1.4;">
                      {{ $t('Common.YourCommentAvailableAllOrganizers') }}
                    </div>
                  </div>
                </div>
              </div>
            </sFormItem>
          </sForm>
        </template>
        <template v-else>
          <div class="font-size-16">
            {{ $t('Common.ThanksFeedback') }}
          </div>
        </template>
      </div>
    </template>
    <template #first_btn>
      <sButton
        v-if="ratingsDialog.modalStep === 1"
        class="mr-7"
        data-qa="modal-rating-btn-evaluate"
        :loading="sendRating"
        @click="setRating()">
        {{ $t('Common.Evaluate') }}
      </sButton>
      <sButton
        v-else-if="$route.name !== 'supplier'"
        class="mr-7"
        data-qa="modal-rating-btn-goToRating`"
        @click="goToRating()">
        {{ $t('Common.GoToRating') }}
      </sButton>
    </template>
    <template #second_btn>
      <sButton
        :class="ratingsDialog.modalStep === 1 ? 'ml-7' : ''"
        :data-qa="`modal-rating-btn-${ratingsDialog.modalStep === 1 ? 'cancel' : 'close'}`"
        :disabled="sendRating"
        :rounded="false"
        type="text"
        @click="ratingsDialog.modalStep === 1 ? ratingsDialog.modal = false : changeStateModalRatind(false)">
        {{ $t(ratingsDialog.modalStep === 1 ? 'Common.Cancel' : 'Common.Close') }}
      </sButton>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import RatingStar from 'components/common/elements/RatingStar.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import SuppliersApi from '@/api/suppliersApi'
const api = new SuppliersApi()

let casheTypeRatings = null

/**
* Диалог проставки рейтинга
* @vue-data {Boolean} sendRating - Признак отправки данных
* @vue-data {Object} ratingsDialog - Объект со свойствами диалогового окна


 * @vue-prop {Number} organizationId - Обязательное. Ключ организации по которой выставляем рейтинг
 * @vue-prop {String} organizationTitle - Название организации
 * @vue-prop {Array} typeRatings - Справочник рейтингов. Если не будет, считает компонент
 * @vue-prop {Boolean} list - Тип эллемента вызова. Кнопка или меню
 */
export default {
  name: 'ratingDialog',
  data() {
    const that = this
    return {
      rules: {
        generalRating: [
          {
            type: 'number',
            trigger: 'change',
            required: true,
            message: that.$t('Tenders.NecessaryIndicateOverallRating')
          }
        ],
        comment: [
          {
            type: 'string',
            trigger: 'blur',
            required: false,
            max: 250,
            message: this.$t('Validate.maxLength', {number: 250, type: this.$tc('Common.characters', 10) })
          }
        ]
      },
      sendRating: false,
      ratingsDialog: {
        modal: false,
        modalStep: 1,
        modalData: {},
        showRatingDetails: false,
      },
    }
  },
  methods: {
    /**
     * Переход на страницу рейтинга
     */
    goToRating() {
      this.$router.push({
        name: 'supplier',
        params: {
          org: this.$route.params.org,
          id: this.organizationId},
        query: {tab: 'rating'}
      })
    },
    /**
     * Заполняем кеш типов отзывов, что б не дергать бек каждый раз
     */
    setCasheTypeRatings(sprTypeRatings) {
      return new Promise((resolve) => {
        if (!casheTypeRatings?.length) {
          casheTypeRatings = sprTypeRatings
          resolve(casheTypeRatings)
        } else {
          resolve(casheTypeRatings)
        }
      })
    },
    /**
     * Проверяем данные в параметре с типами отзывов
     */
    checkExistsCasheTypeRatings() {
      return new Promise((resolve) => {
        if (casheTypeRatings?.length || this.typeRatings?.length) {
          this.setCasheTypeRatings(this.typeRatings || casheTypeRatings).then((resultCasheTypeRatings) => {
            resolve(resultCasheTypeRatings)
          })
        } else {
          this.$store.dispatch('getRatingCriterias').then(res => {
            if (!res?.length) {
              resolve([])
              return
            }
            const typeRatings = res.map(i => {
              return {
                id: i.id,
                criteriaName: i.criteriaName,
                criteriaShortName: i.criteriaShortName || `${i.criteriaName.substring(0, 7)}...`
              }
            })
            this.setCasheTypeRatings(typeRatings).then((resultCasheTypeRatings) => {
              this.$emit('update:typeRatings', resultCasheTypeRatings)
              resolve(resultCasheTypeRatings)
            })
          })
        }
      })
    },
    /**
     * Изменение состояния диалогового окна
     * Сброс данных
     */
    changeStateModalRatind(state) {
      this.sendRating = true
      this.$set(this.ratingsDialog, 'modal', state)
      const checkPromise = new Promise((resolve) => {
        if (state) {
          this.checkExistsCasheTypeRatings().then((resultCasheTypeRatings) => {
            resolve(resultCasheTypeRatings)
          })
        } else {
          resolve([])
        }
      })

      checkPromise.then((resultCasheTypeRatings) => {
        if (!state) {
          this.ratingsDialog.showRatingDetails = false
        }
        this.ratingsDialog.modalStep = 1
        const modelData = {
          sending: false,
          comment: null,
          generalRating: null,
          ratingTypes: [],
          ratingDetails: []
        }
        modelData.ratingTypes = JSON.parse(JSON.stringify(resultCasheTypeRatings))
        modelData.ratingDetails = modelData.ratingTypes.map(i => {
          return {
            criterionId: i.id,
            rating: null
          }
        })
        this.$set(this.ratingsDialog, 'modalData', modelData)
        this.sendRating = false
        if (!state) {
          this.$emit('changeRatings')
        }
      })
    },
    /**
     * Добавление рейтинга
     */
    async setRating() {
      this.$refs.ratingDialogForm.validate(async (valid) => {
        if (!valid) { return }
        this.sendRating = true
        await api.setBidderRating({
          supplierOrganizationId: this.organizationId,
          comment: this.ratingsDialog.modalData.comment,
          generalRating: this.ratingsDialog.modalData.generalRating,
          ratingDetails: this.ratingsDialog.modalData.ratingDetails.filter(i => i.rating)
        }).then(async res => {
          if (res) {
            this.ratingsDialog.modalStep = 2
            this.sendRating = false
            // this.$emit('changeRatings')
          }
        })
          .finally(() => this.sendRating = false)
        this.dialog = false
      })
    },
    getTest() {
      return casheTypeRatings
    }
  },
  props: {
    organizationId: {
      type: Number,
      require: true
    },
    organizationTitle: {
      type: String
    },
    typeRatings: {
      type: Array
    },
    list: {
      type: Boolean
    }
  },
  computed: {
    title() {
      if (this.ratingsDialog.modalStep === 1) {
        return `${this.$t('Suppliers.Evaluation')} "${this.organizationTitle}"`
      }
      return `${this.$t('Suppliers.SupplierEvaluated', {orgTitle: this.organizationTitle})}`
    }
  },
  components: {
    MenuItem,
    RatingStar,
    DialogTemplateToolkit,
  }
}
</script>
<style lang="scss" scoped>
.btn-black {
  background-color: var(--black-color) !important;
  color: var(--white-color);
  line-height: 20px;
  border-radius: 37px;
}

.row-comment{
  margin: 24px 0 0px;
  display: flex;
  justify-content: space-between;
}
.col-textarea {
  max-width: 66%;
}
.col-info {
  max-width: calc(34% - 24px);
}

.arrow {
  width: 8px;
  height: 8px;
  margin: 8px 0 0 8px;
  border-top: 2px solid var(--text-color);
  border-left: 2px solid var(--text-color);
  transition: all 0.5s ease;
  cursor: pointer;
  opacity: 0.8;
  &:hover,
  &:focus {
    border-width: 2px;
    opacity: 1;
  }
  &:before {
    content: '';
    transform: rotate(45deg);
  }
  &.up {
    transform: rotate(45deg);
  }
  &.down {
    transform: rotate(-135deg);
  }
}
</style>
